module.exports = __webpack_public_path__ + "static/media/photo.28701776.jpg";